import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../utils/constants';

export const homepageSlide = css({
  [MediaQueries.md]: {
    width: '100%',
  },

  [MediaQueries.sm]: {
    width: '100%',
  },

  width: 'calc(100% + 75px)',

  '.swiper-slide img': {
    transition: 'opacity 400ms',
  },
  '.swiper-slide.swiper-slide-prev': {
    marginRight: '0px !important',
    img: { opacity: 0 },
  },

  '.regus-button-prev': {
    display: 'none',
  },
  '.regus-button-next': {
    display: 'none',
  },

  '&:hover': {
    '.regus-button-prev': {
      display: 'flex',
      [MediaQueries.sm]: {
        display: 'none',
      },
    },
    '.regus-button-next': {
      display: 'flex',
      [MediaQueries.sm]: {
        display: 'none',
      },
    },
  },

  '.swiper-slide': {
    height: '472px',
    // width: '98% !important',
    img: {
      objectFit: 'cover',
    },
    [MediaQueries.sm]: {
      height: 'auto',
      overflow: 'unset',
      img: {
        height: 'auto',
        objectFit: 'cover',
      },
    },

    [MediaQueries.lg]: {
      height: 'auto',
      objectFit: 'cover',
    },

    [MediaQueries.md]: {
      height: '320px',
      img: {
        height: '320px',
        objectFit: 'cover',
      },
    },
  },

  '.swiper-container': {
    [MediaQueries.sm]: {
      overflow: 'unset',
    },
    [MediaQueries.md]: { width: 'calc(100% + 75px)' },
  },

  '.swiper-container:hover': {
    '.regus-button-prev': {
      display: 'flex',
      [MediaQueries.sm]: {
        display: 'none',
      },
    },
    '.regus-button-next': {
      display: 'flex',
      [MediaQueries.sm]: {
        display: 'none',
      },
    },
  },

  '.swiper-slide.swiper-slide-next': {
    opacity: 0.3,
  },

  '.regus-button-prev': {
    position: 'absolute',
    bottom: '45%',
    zIndex: 99999,
    cursor: 'pointer',
    display: 'none',
    border: '0',
    justifyContent: 'center',
    alignItems: 'center',
    outline: '0px',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
    left: '13px',
    [MediaQueries.lg]: {
      bottom: '50%',
      left: '0px',
    },
    [MediaQueries.md]: {
      bottom: '63%',
      left: '-5px',
    },
  },

  '.regus-button-next': {
    position: 'absolute',
    bottom: '45%',
    cursor: 'pointer',
    display: 'none',
    zIndex: 99999,
    width: '48px',
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.12)',
    height: '48px',
    borderRadius: '50%',
    outline: '0px',
    border: '0',
    backgroundColor: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
    right: '-48px',
    [MediaQueries.lg]: {
      bottom: '50%',
      right: '-60px',
    },
    [MediaQueries.md]: {
      bottom: '63%',
      right: '-60px',
    },
  },

  img: {
    width: '100%',
    Height: '481px',
  },
});
